import { ProductType } from '@/data/types/Product';
import { CDN_BASE_URL } from 'shared/custom/constants/commonConstants';

// TODO: figure out how the Img component from MaterialImage or Image from next/image can be used here
// import { Img } from '@/components/blocks/MaterialImage';
export const ProductImage = ({ product }: { product: ProductType }) => {
	const partNumber = product.partNumber;
	const src = `${CDN_BASE_URL}/productos/${partNumber}/${partNumber}.jpg`;
	const alt = product.name;

	return (
		// eslint-disable-next-line @next/next/no-img-element, react/forbid-elements
		<img
			src={src}
			style={{
				background: 'white',
				width: '100%',
				height: 'auto',
				aspectRatio: '1/1',
				objectFit: 'contain',
			}}
			width={274}
			height={274}
			alt={alt}
		/>
	);
};
